export const en = {
    'click-value': 'CPC: {value}',
    holidays: 'On holidays',
    time: 'Time',
    'time-correction': 'Bid adjustment by time',
    timezone: 'Time zone',
    'with-working-weekends': 'Include working weekends'
};
